import Rbac from "../../../utils/Rbac";
import {isViewVisible} from "../../../utils/ViewSettings";
import React from "react";
import UsersView from "./components/UserComponents/UsersView";
import UserGroupsView from "./components/UserGroupComponents/UserGroupsView";
import MessagesView from "./components/MessageComponents/MessagesView";
import EmailSettingsView from "./components/EmailSettingsView";

export const rbac = new Rbac({
    _rbac: {
        "admin": {
            write: true,
            editUser: true,
            delete: true,
            bookingInfo: true,
            mailSettings: true,
            groupList: true,
            editMessage: true,
            viewMessage: true,
            deleteMessage: true,
            messages: true
        },
        "manager": {
            write: true,
            editUser: true,
            delete: true,
            bookingInfo: true,
            mailSettings: true,
            groupList: true,
            editMessage: true,
            viewMessage: true,
            deleteMessage: true,
            messages: true
        },
        "booking-manager": {
            write: true,
            editUser: true,
            delete: false,
            bookingInfo: true,
            mailSettings: true,
            groupList: true,
            editMessage: false,
            viewMessage: false,
            deleteMessage: false,
            messages: false
        },
        "manager-location": {
            write: true,
            editUser: true,
            delete: false,
            bookingInfo: true,
            mailSettings: true,
            groupList: true,
            editMessage: false,
            viewMessage: false,
            deleteMessage: false,
            messages: false
        },
        "mediator": {
            write: true,
            editUser: true,
            delete: false,
            bookingInfo: true,
            mailSettings: true,
            groupList: true,
            editMessage: false,
            viewMessage: false,
            deleteMessage: false,
            messages: false
        },
        "user": {
            write: false,
            editUser: false,
            delete: false,
            bookingInfo: false,
            mailSettings: false,
            groupList: false,
            editMessage: false,
            viewMessage: false,
            deleteMessage: false,
            messages: false
        },
        "garage-staff": {
            write: false,
            editUser: false,
            delete: false,
            bookingInfo: true,
            mailSettings: true,
            groupList: true,
            editMessage: false,
            viewMessage: false,
            deleteMessage: false,
            messages: false
        }
    }
});

export const UsersPage = props => {
    let _view = typeof props.view === 'undefined' || props.view === null ? 'index' : props.view;
    let indexView = isViewVisible('users','users') ? 'users' : '';
    return (
        <>
            {(_view === 'users' || (_view === 'index' && indexView === 'users')) &&
                <UsersView
                    name={"users"}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                    action={props.action}
                />
            }
            {(_view === 'usergroups') &&
                <UserGroupsView
                    name={"usergroups"}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                />
            }
            {(_view === 'messages') &&
                <MessagesView
                    name={"messages"}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                />
            }
            {(_view === 'mailsettings') &&
                <EmailSettingsView
                    name={"emailsettings"}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                />
            }
        </>
    );
}